import { CustomerDataStore } from "./CustomerDataStore";
import { CustomerCartStore } from "./customer-cart/CustomerCartStore";
import { PriceConfigStore } from "./PriceConfigStore";
import { AnonCartStore } from "./anon-cart/AnonCartStore";
import { CustomerCartItemStore } from "./common-cart/CartItemStore";
import SelectedStoreInfoStore from "./checkout/SelectedStoreInfoStore";
import { CountryStoresStore } from "./checkout/CountryStoresStore";
import { MiniCartStoreImpl } from "./MiniCartStore";
import { AnonCartDebugPageStoreImpl } from "./anon-cart/AnonCartDebugPageStore";
import { SideCaddyStoreImpl } from "./SideCaddyStore";
import { CartRecommendationStoreImpl } from "./customer-cart/CartRecommendationStore";
import { isAnonCartEnabled } from "../ABFeatures";
export const MiniCartStore = new MiniCartStoreImpl(
	CustomerCartStore,
	"/cart",
	"lastCustCartPopoverId",
	false,
	"ORC_SHOPPINGCART_CHANGED_ARTICLE_AMOUNT_CHANGED_WITHOUT_DESCR",
	"ORC_SHOPPINGCART_CHANGED_ARTICLE_AMOUNT_CHANGED_WITHOUT_DESCR",
	PriceConfigStore
);
export const AnonMiniCartStore = new MiniCartStoreImpl(
	AnonCartStore,
	"/anon-cart",
	"lastAnonCartPopoverId",
	!isAnonCartEnabled(),
	"ORC_SHOPPINGCART_CHANGED_ARTICLE_AMOUNT_CHANGED_WITHOUT_DESCR",
	"ORC_SHOPPINGCART_CHANGED_ARTICLE_AMOUNT_CHANGED_WITHOUT_DESCR",
	PriceConfigStore
);
export const AnonCartDebugPageStore = new AnonCartDebugPageStoreImpl(AnonCartStore);
export const SideCaddyStore = new SideCaddyStoreImpl(
	CustomerCartStore,
	CustomerDataStore,
	SelectedStoreInfoStore,
	CountryStoresStore,
	PriceConfigStore
);
export const CartRecommendationStore = new CartRecommendationStoreImpl(CustomerCartStore, CustomerCartItemStore);
